import React from 'react';
import defaultImg from '../../assets/img/nophoto.png'
import moment from 'moment'
import {Link} from "react-router-dom";

const SendPropertyChatCard = ({isSender,time,image,id,title,price,name}) => {
    return (
        <div className="row no-gutters">
            <div className={`msg-box ${isSender && 'ml-auto'}`}>
                <Link to={`/new-property-details/${id}`}>
                <div className={`chat-bubble chat-bubble-share  ${isSender ? 'chat-bubble--right' : 'chat-bubble--left'}`}>

                    <div className={`share-image ${name && "share-image-bg"}`}>
                        {(name && !isSender)&&<span className="text-primary">Shared By - @{name}</span>}
                        {/*<img src={defaultImg} alt="Share Property Image"/>*/}
                        <img src={image?image:defaultImg} alt="Share Property Image"/>
                    </div>

                    <div className={"share-detail"}>
                        <Link to={`/new-property-details/${id}`}>{title}</Link>
                        <p>price:- {price}</p>
                        <small className="d-block text-right mr-2"><i className="fas fa-check"/> {moment(time).utc().fromNow(true)}</small>
                    </div>

                </div>
                </Link>
            </div>
        </div>
    );
};

export default SendPropertyChatCard;